import {TextWithImageLazy} from 'app/components/textWithImageSSR/lazy';
import {shouldSkipLazyLoadCompat} from 'app/components/textWithImageSSR/shouldSkipLazyLoad';
import {getWebComponentLoader} from 'app/utils/initialize/getWebComponentLoader';

export function defineTextWithImage(WebComponentLoader: ReturnType<typeof getWebComponentLoader>) {
    if (customElements.get('gem-text-with-image')) {
        return;
    }

    customElements.define(
        'gem-text-with-image',
        class extends WebComponentLoader {
            reactLazyComponent = TextWithImageLazy;
            shouldSkipLazyLoad = shouldSkipLazyLoadCompat;
        },
    );
}
